<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Yönetim Paneli</p>
      </sidebar-link>
      <sidebar-link to="/admin/users">
        <i class="nc-icon nc-circle-09"></i>
        <p>Kullanıcı Yönetimi</p>
      </sidebar-link>
      <sidebar-link to="/admin/money-boxes">
        <i class="nc-icon nc-money-coins"></i>
        <p>Kumbara Yönetimi</p>
      </sidebar-link>
      <sidebar-link to="/admin/corporations">
        <i class="nc-icon nc-money-coins"></i>
        <p>İşletme Yönetimi</p>
      </sidebar-link>
      <sidebar-link to="/admin/segments">
        <i class="nc-icon nc-layers-3"></i>
        <p>Segment Yönetimi</p>
      </sidebar-link>
      <sidebar-link to="/admin/reports">
        <i class="nc-icon nc-chart-bar-32"></i>
        <p>Raporlar</p>
      </sidebar-link>
      <!--<sidebar-link to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/admin/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
